// components/PrintableUsers.jsx
import React, { useState, useEffect, useContext } from "react";
import { Select, Button, message, Typography,
    Divider } from "antd";
import axios from "axios";
import AuthContext from "../../context/authContext";
import { QRCodeCanvas } from "qrcode.react";
import streenLogo from "../../img/logo.png";
import {    
    PrinterOutlined  
  } from "@ant-design/icons";

const { Title } = Typography;
const { Option } = Select;

const PrintableUsers = () => {
  const { currentUser } = useContext(AuthContext);
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [printable, setPrintable] = useState([]);

  // Fetch all users once currentUser is available
  useEffect(() => {
    if (!currentUser) return;

    axios
      .get("/api/users", { withCredentials: true })
      .then((res) => setUsers(res.data))
      .catch((err) => {
        if (err.response?.status !== 401) console.error(err);
      });
  }, [currentUser]);

  // Generate printable users
  const handleGeneratePrintable = async () => {
    if (!selectedUsers.length) return;

    try {
      const res = await axios.post(
        "/api/auth/resetprint",
        { userIds: selectedUsers },
        { withCredentials: true }
      );
      setPrintable(res.data);
    } catch (err) {
      console.error(err);
      message.error(
        err.response?.data || "Fehler beim Generieren der Druckliste"
      );
    }
  };

  // Print function
  const handlePrint = () => {
    window.print();
  };

  // Only allow teachers/admins to see this component
  if (!currentUser || (currentUser.role !== 0 && currentUser.role !== 1)) {
    return null;
  }

  return (
    <div>
     <div style={{maxWidth: 640, margin: "0 auto", padding: "20px 0" }} >
     
     <Title level={2}>
          <span>
            <PrinterOutlined /> Benutzer drucken
          </span>
        </Title>

        <Divider />
     
      
      <p>Wählen Sie die Schüler für den Druck aus:</p>

      <Select
        mode="multiple"
        style={{ width: "100%" }}
        placeholder="Wählen Sie Benutzer"
        value={selectedUsers}
        onChange={setSelectedUsers}
      >
        {users.map((user) => (
          <Option key={user.id} value={user.id}>
            {user.username}
          </Option>
        ))}
      </Select>

      <div style={{ textAlign: "center", margin: "16px 0" }}>
        <Button
          type="primary"
          onClick={handleGeneratePrintable}
          disabled={!selectedUsers.length}
        >
          Drucken generieren
        </Button>
      </div>

      {printable.length > 0 && (
        <div className="print-area" style={{ marginTop: 24 }}>
          {printable.map((u) => (
            <div
              key={u.id}
              style={{
                textAlign: "center",
            marginTop: 24,
            padding: 24,
            border: "1px solid #ddd",
            borderRadius: 12,
            background: "#fff",
              }}
            >
              <img src={streenLogo} alt="STREEN" style={{ width: 100 }} />
              <p>
                <strong>Benutzername:</strong> {u.username}
              </p>
              <p>
                <strong>Passwort:</strong> {u.password}
              </p>
              <QRCodeCanvas value={u.qr_code} size={120} />
            </div>
          ))}

          <div style={{ textAlign: "center", marginTop: 16 }}>
            <Button type="primary" onClick={handlePrint}>
              Drucken
            </Button>
          </div>
        </div>
      )}
    </div>
    </div>
  );
};

export default PrintableUsers;
